




























































































































































































import VueHtml2pdf from "./VueHtml2pdf.vue";
import ControlsContainer from "./ControlsContainer.vue";
import SearchForm from "./treatment-monitoring/SearchForm.vue";
import Vue from "vue";
import Component from "vue-class-component";
import {
  ShipmentCertificateModel,
  ShipmentCertificatesApi,
  TreatmentRequestCertificateModel,
  TreatmentRequestGraphModel,
  TreatmentRequestsApi,
  WebConfigsApi,
  WebConfigModel,
} from "../../apis";
import QrcodeVue from "qrcode.vue";
import { Prop, Ref } from "vue-property-decorator";
import moment from "moment-timezone";
@Component({
  components: {
    VueHtml2pdf,
    ControlsContainer,
    QrcodeVue,
    SearchForm,
  },
})
export default class CertificateGraph extends Vue {
  @Prop({ default: false }) isExportPdf!: boolean;
  @Ref("graph") readonly graph!: InstanceType<typeof SearchForm>;
  @Ref("graphO2") readonly graphO2!: InstanceType<typeof SearchForm>;

  contentRendered = false;
  lotStr = "";
  O2variables= [];
  progress = 0;
  generatingPdf = false;
  pdfDownloaded = false;
  controlValue = {
    showLayout: false,
    floatLayout: true,
    enableDownload: true,
    previewModal: true,
    paginateElementsByHeight: 1300,
    manualPagination: false,
    filename: "",
    pdfQuality: 2,
    pdfFormat: "a3",
    pdfOrientation: "landscape",
    pdfContentWidth: "1587px",
    reviewMode: false,
  };

  insect = "";
  condition = "";

  certificate: TreatmentRequestCertificateModel = Object.assign({});
  exportTreatmentGraph: TreatmentRequestGraphModel = Object.assign({});
  webConfig: WebConfigModel = null;

  phoneT: string = "";
  phoneF: string = "";
  formatTimezone(time){
    let  offset = 0;
    if (this.certificate && this.certificate.locationTimeZone){
        const now = new Date();
        const locationTime = now.toLocaleString("en-US", {timeZone: this.certificate.locationTimeZone});
        const subdate = new Date(locationTime);
        offset = Math.round((subdate.getTime() - now.getTime())/1000);
    }
    return moment(time).add(offset, "second").format("DD MMM YYYY HH:mm");
  }
  async created() {
    this.$util.showLoading();
    try {
      const [certificateTreatmentRequestRs, exportTreatmentGraphRs, configRs] = await Promise.all([
        new TreatmentRequestsApi().viewCertificateTreatmentRequest({
          id: this.$route.params.id,
        }),
        new TreatmentRequestsApi().exportTreatmentGraph({
          id: this.$route.params.id,
        }),
        new WebConfigsApi().getDefaultWebConfig()
      ]);
      this.certificate = certificateTreatmentRequestRs.data.data;
      this.exportTreatmentGraph = exportTreatmentGraphRs.data.data;
      this.webConfig = configRs.data.data;
      [this.phoneT, this.phoneF] = this.webConfig.graphPhone.split(" - ");
      this.insect = (this.exportTreatmentGraph.insectValue as any).map(insect => insect.name).join("/ ");
      const lotsArr: string[] = [];
      if (this.exportTreatmentGraph.setPointValue && this.exportTreatmentGraph.setPointValue[0]){
        this.O2variables = [this.exportTreatmentGraph.setPointValue[0]['actualVariable'], this.exportTreatmentGraph.setPointValue[0]['variable']];
      }
      if (this.certificate.weights){
        for (let index = 0; index < this.certificate.weights.length; index++) {
          const element = this.certificate.weights[index];
          if (element['lotNumber']){
            lotsArr.push(element['lotNumber']);
          }
        }
      }
      this.lotStr = lotsArr.join('; ');

      const setPointCondition: string[] = [];
      if (this.exportTreatmentGraph.setPointValue[1]){
        setPointCondition.push(`${this.exportTreatmentGraph.setPointValue[1]['value']}°C`);
      }
      if (this.exportTreatmentGraph.setPointValue[0]){
        setPointCondition.push(`${this.exportTreatmentGraph.setPointValue[0]['value']}% O₂`);
      }

      this.condition = [...setPointCondition, `for at least ${this.certificate.treatmentTime} ${(this.certificate.treatmentFormat || "").toLowerCase()}`].join(", ");
      // const conditionNo = this.certificate.conditionNo;
      // switch (conditionNo) {
      //   case 3:
      //     this.condition =  this.certificate.isPallet ? this.webConfig.condition3 : this.webConfig.condition3CA;
      //     break;
      //   case 2:
      //     this.condition =  this.certificate.isPallet ? this.webConfig.condition2 : this.webConfig.condition2CA;
      //     break;
      
      //   default:
      //      this.condition = this.certificate.isPallet ? this.webConfig.condition1 : this.webConfig.condition1CA;
      //     break;
      // }
    } catch (error) {
      this.$util.showError(error);
    }
  }

  onLoad() {
    if (this.graph){
      this.graph.searchForm.dateStart = "";
      this.graph.searchForm.dateEnd = "";
      this.graph.searchForm.treatmentId = this.certificate.id;
    }
    if (this.graphO2){
      this.graphO2.searchForm.dateStart = "";
      this.graphO2.searchForm.dateEnd = "";
      this.graphO2.searchForm.treatmentId = this.certificate.id;
    }
    // this.graph.doSearch();
  }

  getHref() {
    return window.location.href;
  }

  get TREATMENTS() {
    return Array.of(this.certificate);
  }

  get htmlToPdfOptions() {
    return {
      margin: 0,
      filename: this.certificate.number + ' Graph',
      image: {
        type: "jpeg",
        quality: 0.98,
      },
      enableLinks: true,
      html2canvas: {
        scale: this.controlValue.pdfQuality,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: this.controlValue.pdfFormat,
        orientation: this.controlValue.pdfOrientation,
      },
    };
  }
  async downloadPdf() {
    if (!(await this.validateControlValue())) return;
    (this.$refs.html2Pdf as any).generatePdf();
  }
  validateControlValue() {
    if (this.controlValue.pdfQuality > 2) {
      alert("pdf-quality value should only be 0 - 2");
      this.controlValue.pdfQuality = 2;
      return false;
    }
    if (!this.controlValue.paginateElementsByHeight) {
      alert("paginate-elements-by-height value cannot be empty");
      this.controlValue.paginateElementsByHeight = 1400;
      return false;
    }
    const paperSizes = [
      "a0",
      "a1",
      "a2",
      "a3",
      "a4",
      "letter",
      "legal",
      "a5",
      "a6",
      "a7",
      "a8",
      "a9",
      "a10",
    ];
    if (!paperSizes.includes(this.controlValue.pdfFormat)) {
      alert(`pdf-format value should only be ${paperSizes}`);
      this.controlValue.pdfFormat = "a4";
      return false;
    }
    if (!this.controlValue.pdfOrientation) {
      alert("pdf-orientation value cannot be empty");
      this.controlValue.pdfOrientation = "portrait";
      return false;
    }
    if (!this.controlValue.pdfContentWidth) {
      alert("pdf-content-width value cannot be empty");
      this.controlValue.pdfContentWidth = "800px";
      return false;
    }
    return true;
  }
  onProgress(progress) {
    this.progress = progress;
    console.log(`PDF generation progress: ${progress}%`);
  }
  startPagination() {
    console.log(`PDF has started pagination`);
  }
  hasPaginated() {
    console.log(`PDF has been paginated`);
  }
  async beforeDownload({ html2pdf, options, pdfContent }) {
    console.log(`On Before PDF Generation`);
    // await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
    // 	const totalPages = pdf.internal.getNumberOfPages()
    // 	for (let i = 1; i <= totalPages; i++) {
    // 		pdf.setPage(i)
    // 		pdf.setFontSize(10)
    // 		pdf.setTextColor(150)
    // 		pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
    // 	}
    // }).save()
  }
  hasDownloaded(blobPdf) {
    console.log(`PDF has downloaded yehey`);
    this.pdfDownloaded = true;
    this.controlValue.reviewMode = false;
    console.log(blobPdf);
  }
  domRendered() {
    console.log("Dom Has Rendered");
    this.contentRendered = true;
  }
  onBlobGenerate(blob) {
    console.log(blob);
  }
}
